var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-dialer-call-card-avatars",
      class: ((_obj = {}), (_obj["is-" + _vm.size] = true), _obj),
    },
    [
      _vm.isContactVisible
        ? _c("contact-avatar", {
            attrs: { person: _vm.contact, avatar: _vm.avatar },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAgentAvatar
        ? _c("agent-avatar", {
            attrs: { person: _vm.agent, avatar: _vm.avatar },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.visibleAvatars, function (member) {
        return _c(_vm.getAvatarType(member), {
          key: member.memberId,
          tag: "component",
          attrs: { person: _vm.getPerson(member), avatar: _vm.avatar },
        })
      }),
      _vm._v(" "),
      _vm.additionalAvatarsLabel
        ? _c(
            "div",
            {
              staticClass: "additional-avatars",
              class: { rounded: _vm.avatar.rounded },
            },
            [_vm._v("\n    " + _vm._s(_vm.additionalAvatarsLabel) + "\n  ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }